import type { HTMLAttributes } from 'react';
import React from 'react';
import classNames from 'classnames';
import { Styled } from './styled';

export interface SmallLabelProps extends HTMLAttributes<HTMLDivElement> {
  readonly children?: React.ReactText;
}

export function SmallLabel({ className, children, ...props }: SmallLabelProps): JSX.Element {
  return (
    <Styled className={classNames(SmallLabel.displayName, className)} {...props}>
      {children}
    </Styled>
  );
}
SmallLabel.displayName = 'SmallLabel';
